import React, {useState} from 'react';
import './Navbar.scss';
import {MdCatchingPokemon} from 'react-icons/md';
import {AiOutlineCloseCircle} from 'react-icons/ai';
import images from '../../constants/images';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false)

  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={images.logo} alt="logo" />
      </div>

      <ul className='app__navbar-links'>
        <li className='p__poppins'><a href='#home'>Home</a></li>
        <li className='p__poppins'><a href='#project'>Project</a></li>
        <li className='p__poppins'><a href='#contact'>Contact</a></li>
      </ul>

      <div className='app__navbar-smallscreen'>
        <MdCatchingPokemon className='app__navbar-smallscreen_pokeball' onClick={()=>setToggleMenu(true)}/>

        {toggleMenu && (
          <div className='app__navbar-smallscreen_overlay flex__center slide-bottom'>
            <AiOutlineCloseCircle className='overlay__close' onClick={()=>setToggleMenu(false)}/>

            <ul className='app__navbar-smallscreen_links'>
              <li className='p__poppins' onClick={()=>setToggleMenu(false)}><a href='#home'>Home</a></li>
              <li className='p__poppins' onClick={()=>setToggleMenu(false)}><a href='#project'>Project</a></li>
              <li className='p__poppins' onClick={()=>setToggleMenu(false)}><a href='#contact'>Contact</a></li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar